import { defineMessages } from 'react-intl';

export const clinicianTrialNavCardMessages = defineMessages({
  region: {
    defaultMessage: 'Clinician trial',
    id: 'TeR08MdLOt',
    description:
      'Accessible name of the sidebar card about a new user’s Heidi II Clinician trial',
  },
  title: {
    defaultMessage: '{count, plural, one {# trial day left} other {# trial days left}}',
    id: 'ANoFNVDeIC',
    description: 'Title of the sidebar Clinician trial card; count is whole days left',
  },
  body: {
    defaultMessage:
      'Your Clinician trial ends {date}. <learnMore>Learn more.</learnMore>',
    id: '12V0n+tLHz',
    description:
      'Sidebar Clinician trial card body with more than 7 days left; date is when the trial ends, Learn more links to the usage limits article',
  },
  bodyLastWeek: {
    defaultMessage:
      'Your Clinician trial with complimentary Max usage ends {date}. <learnMore>Learn more.</learnMore>',
    id: 'Kqqi0TqJ8t',
    description:
      'Sidebar Clinician trial card body in the last 7 days; date is when the trial ends, Learn more links to the usage limits article',
  },
  upgrade: {
    defaultMessage: 'Upgrade',
    id: 'a2X8PAoo60',
    description:
      'Primary button in the sidebar Clinician trial card; opens the pricing plans',
  },
  extendTrial: {
    defaultMessage: 'Extend your trial',
    id: 'uWzNmzscqu',
    description:
      'Secondary button in the sidebar Clinician trial card; opens the trial extension checklist',
  },
  close: {
    defaultMessage: 'Close',
    id: 'vYz8JPmWAd',
    description:
      'Accessible label of the close button on the sidebar Clinician trial card',
  },
});
